// The languages of the site, in picker order; the first segment of every URL is one of them (`/ru/cookbook`)
export const LANGUAGES = ['en', 'es', 'ru'] as const;

export type Language = (typeof LANGUAGES)[number];

// For a visitor with neither a remembered nor a browser language the site has
export const FALLBACK_LANGUAGE: Language = 'en';

export const isLanguage = (value: string | undefined): value is Language =>
    (LANGUAGES as readonly (string | undefined)[]).includes(value);

// i18next's resolvedLanguage as a site language: supportedLngs keeps it one already, the fallback only satisfies types
export const asLanguage = (value: string | undefined): Language => (isLanguage(value) ? value : FALLBACK_LANGUAGE);
